/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const SugarBeet = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="12"
    height="20"
    fill="none"
    viewBox="0 0 12 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.6928 19.176C4.9368 19.176 4.5888 18.5568 4.2696 17.556C3.7416 15.9288 2.9256 14.8344 2.136 13.776C2.088 13.7112 2.04 13.6488 1.9944 13.584C1.0128 12.264 0 10.896 0 8.904C0 7.8192 0.384 6.8424 1.1112 6.0792C1.8264 5.328 2.8536 4.8024 4.0848 4.5576L4.2672 4.5216L2.3064 1.8048L3.48 0.9816L5.0448 3.156V0H6.4608V3.1584L7.7808 1.464L8.8896 2.304L7.2144 4.5432L7.3992 4.5816C8.6016 4.8264 9.6072 5.352 10.3056 6.1008C11.0136 6.8592 11.388 7.8288 11.388 8.904C11.388 10.896 10.3752 12.264 9.3936 13.584C9.3384 13.6584 9.2856 13.7304 9.2304 13.8048C8.448 14.8584 7.6392 15.9456 7.1184 17.556C6.7968 18.5568 6.4488 19.176 5.6928 19.176ZM5.6928 5.904C4.428 5.904 3.372 6.1896 2.64 6.7296C1.9176 7.2624 1.536 8.0136 1.536 8.904C1.536 10.4352 2.352 11.5344 3.2136 12.6984L3.2664 12.768C3.96 13.6848 4.6872 14.7 5.3184 16.1064C5.3424 16.1568 5.364 16.2144 5.3856 16.2672C5.4672 16.476 5.5392 16.656 5.6928 16.656C5.8464 16.656 5.9184 16.476 6 16.2672C6.0216 16.212 6.0432 16.1568 6.0672 16.104C6.7032 14.6856 7.4592 13.6392 8.1192 12.768L8.172 12.696C9.0336 11.532 9.8496 10.4328 9.8496 8.9016C9.8496 8.0112 9.468 7.2576 8.7456 6.7272C8.0136 6.1896 6.9576 5.904 5.6928 5.904Z" fill="currentColor" />
  </svg>

);

SugarBeet.propTypes = propTypes;

export default SugarBeet;
